// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__XWg-k","vLegacy":"SelectSecondary_vLegacy__1lMwA","error":"SelectSecondary_error__2sWPJ","disabled":"SelectSecondary_disabled__3ey_z"};